import { Sprite, Texture } from 'pixi.js';

/** 使用 Canvas 生成 Pixi 可复用的线性渐变纹理。 */
export function createLinearGradientTexture(
  stops: Array<[number, string]>,
  width = 256,
  height = 16
): Texture {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  if (!context) return Texture.WHITE;

  const gradient = context.createLinearGradient(0, 0, width, 0);
  for (const [offset, color] of stops) {
    gradient.addColorStop(offset, color);
  }

  context.fillStyle = gradient;
  context.fillRect(0, 0, width, height);

  return Texture.from(canvas);
}

/** 创建默认隐藏的阴影精灵，由渲染器按翻页状态控制显示。 */
export function createShadowSprite(stops: Array<[number, string]>): Sprite {
  const sprite = new Sprite(createLinearGradientTexture(stops));
  sprite.visible = false;
  return sprite;
}
